import { environment } from "@/enviroment";
import { Category, CategoryRepository } from "../domain/category";

const BASE_URL = `${environment.openBaas}/v1/categories`;

export class HttpCategoryRepository implements CategoryRepository {
  async create(category: Category): Promise<Category> {
    const res = await fetch(`${BASE_URL}`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(category),
    });

    if (!res.ok) throw new Error("Failed to create category");
    const data = await res.json();
    return data.response;
  }

  async get(): Promise<Category[]> {
    const res = await fetch(`${BASE_URL}`, {
      credentials: "include",
    });

    if (!res.ok) throw new Error("Failed to fetch categories");
    const data = await res.json();
    return data.response;
  }

  async getById(id: string): Promise<Category | null> {
    const res = await fetch(`${BASE_URL}/${id}`, {
      credentials: "include",
    });

    if (res.status === 404) return null;
    if (!res.ok) throw new Error("Failed to fetch category");
    const data = await res.json();
    return data.response;
  }

  async update(category: Category): Promise<Category> {
    const res = await fetch(`${BASE_URL}/${category.id}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(category),
    });

    if (!res.ok) {
      if (res.status === 404) {
        throw new Error("Category not found");
      }
      throw new Error("Failed to update category");
    }
    const data = await res.json();
    return data.response;
  }

  async delete(id: string): Promise<void> {
    const res = await fetch(`${BASE_URL}/${id}`, {
      method: "DELETE",
      credentials: "include",
    });

    if (!res.ok) throw new Error("Failed to delete category");
  }
}
